import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/Login.vue'
import Home from '@/views/Home.vue'
import AppList from '@/views/AppList.vue'
import Category from '@/views/Category.vue'
import Content from '@/views/Content.vue'
import User from '@/views/User.vue'

Vue.use(Router)

const router = new Router({
  routes: [
    { path: '/', redirect: '/login' },
    { path: '/login', component: Login },
    {
      path: '/home',
      component: Home,
      children: [
        { path: 'app', component: AppList },
        { path: 'category', component: Category },
        { path: 'content', component: Content },
         { path: 'user', component: User },
         {path:'style',component:()=>import('@/views/Style.vue')},
         {
          path:'agreement',
          component:()=>import('@/views/Agreement.vue')
         }
      ]
    }
  ]
})

// 路由守卫：必须登录才能进
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('adminToken')
  if (to.path !== '/login' && !token) {
    next('/login')
  } else {
    next()
  }
})

export default router